import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormArray } from '@angular/forms';
import { AgencyService } from './agency.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agency',
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.css']
})
export class AgencyComponent implements OnInit {
agencyDetailsFlag:any=false
staffForm!: FormGroup
agencyForm!: FormGroup
selectedAgencyId:any
token:any
selectedAgencyDetails:any
image:any
agencyDetails:any=[]
addStaffFlag:any=false
editStaffFlag:any=false
addAgencyFlag:any=false
editAgencyFlag:any=false
selectedStaffData:any={}
viewStaffFlag:any=false
popUp:any=false
staffDetails:any=[]
searchQuery:any=''
userTypes:any=[]
userTypeId:any
  constructor(private formBuilder: FormBuilder,private agencyService:AgencyService) { }
// install pdf viewer
// Api integration with all main url
// add edit agency design integratio
// settings form integration
  ngOnInit(): void {
    this.token = localStorage.getItem('token');
  this.listUserType()
    this.staffForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      phoneNumber: ['', [Validators.required,]],
      whatsAppNumber: ['', [Validators.required,]],
      address: ['', [Validators.required,]],
      email: ['', [Validators.required,]],
      userName: ['', [Validators.required,]],
      password: ['', [Validators.required,]],
      photo:['',[Validators.required]],
      coverImage:['',[Validators.required]],

    })


    this.agencyForm = this.formBuilder.group({
      agencyName: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      contractUpload: ['', [Validators.required,]],
      logo: ['', [Validators.required,]],
      coverImage: ['', [Validators.required,]],
      address: ['', [Validators.required,]],
      owner: ['', [Validators.required,]],
      email: ['', [Validators.required,]],
      contactNumber:['',[Validators.required]],
      ownerImage:['',[Validators.required]],
      ownerCoverImage:['',[Validators.required]],


    })


   this.listAgency()
  }



  listUserType(){
    this.agencyService.listUserType(this.token)
    .subscribe((response: any) => {
      if (response.status === 1) {
              this.userTypes =response.data
  
            this.userTypes.map((each:any)=>{


              if(each.userType=='Client Admin'){

                this.userTypeId=each._id
              }
            })
  
      }
    })
   
  }

listAgency(){

  this.agencyService.listAgency(this.token)
  .subscribe((response: any) => {
    if (response.status === 1) {
            this.agencyDetails =response.data


         
          
            if(this.agencyDetails.length>0){

             this.selectAgency(this.agencyDetails[0]._id)

              
            }

    }
  })
 

//   this.agencyDetails=[
//     {
//         "_id": "66ae06bf8a841df42183d6c7",
//         "agencyId": "66ae06bf8a841df42183d6c7",
//         "agencyName": "Example Agency",
//         "contractUpload": "http://example.com/agreement1.pdf",
//         "logo": "../../assets/images/user1.jpeg",
//         "coverImage": "../../assets/images/pic1.jpg",
//         "address": "1234 Main St, Anytown, USA",
//         "owner": "John Doe",
//         "email": "john.doe@example.com",
//         "contactNumber": "+1234567890",
//         "ownerImage": "../../assets/images/user1.jpeg",
//         "ownerCoverImage": "../../assets/images/pic1.jpg",
//         "isActive": true,
//         "createdAt": "2024-08-03T10:30:23.294Z",
//         "updatedAt": "2024-08-03T11:14:39.699Z",
//         "__v": 0
//     },
//     {
        
//       "_id": "66ae06bf8a841df42183d6c7",
//       "agencyId": "66ae06bf8a841df42183d6c7",
//       "agencyName": "Example Agency",
//       "contractUpload": "http://example.com/agreement1.pdf",
//       "logo": "../../assets/images/user1.jpeg",
//       "coverImage": "../../assets/images/pic1.jpg",
//       "address": "1234 Main St, Anytown, USA",
//       "owner": "John Doe",
//       "email": "john.doe@example.com",
//       "contactNumber": "+1234567890",
//       "ownerImage": "../../assets/images/user1.jpeg",
//       "ownerCoverImage": "../../assets/images/pic1.jpg",
//       "isActive": true,
//       "createdAt": "2024-08-03T10:30:23.294Z",
//       "updatedAt": "2024-08-03T11:14:39.699Z",
//       "__v": 0
//     }
// ]

  
}

  selectAgency(id: any) {
    
    this.selectedAgencyId = id 
    // this.selectedAgencyDetails = this.agencyDetails.find((each: any) => {
    //   return each.id === this.selectedAgencyId;
    // });
    
 
            this.agencyService.listSingleAgency(this.token, this.selectedAgencyId)
            .subscribe((response: any) => {
              if (response.status === 1) {
                this.selectedAgencyDetails=response.AgeacyDetails
                this.staffDetails=response.data
              }
              })

        //     this.selectedAgencyDetails= {
              
        //       "agencyId": "Agency-001",
        //       "agencyName": "Example Agency",
        //       "contractUpload": "http://example.com/agreement1.pdf",
        //       "logo": "../../assets/images/pic1.jpg",
        //       "coverImage": "../../assets/images/user1.jpeg",
        //       "address": "1234 Main St, Anytown, USA",
        //       "owner": "John Doe",
        //       "email": "john.doe@example.com",
        //       "contactNumber": "+1234567890",
        //       "ownerImage": "../../assets/images/pic1.jpg",
        //       "ownerCoverImage": "../../assets/images/user1.jpeg",
        //       "isActive": true,
        //       "_id": "66ae06bf8a841df42183d6c7",
        //       "createdAt": "2024-08-03T10:30:23.294Z",
        //       "updatedAt": "2024-08-03T10:30:23.294Z",
        //       "__v": 0
          
        //     }

        //    this.staffDetails= [
        //     {
        //         "_id": "66b03f706a932dfef9661af1",
        //         "name": "Athira vinod",
        //         "phoneNumber": "1234567890",
        //         "whatsAppNumber": "0987654321",
        //         "password": "$2a$10$JsZkwxVRsjsPWl4COih8/OcTua6sRcHo.rLiJ4N5/hg8ORknYIcFG",
        //         "photo": "../../assets/images/user1.jpeg",
        //         "address": "updated",
        //         "email": "athira@gmail.com",
        //         "userName": "athira123",
        //         "employeeCode": "2024/08/05-EMP02",
        //          "coverImage": "../../assets/images/user1.jpeg",
        //         "agencyRefId": {
        //             "_id": "66ae06bf8a841df42183d6c7",
        //             "agencyId": "66ae06bf8a841df42183d6c7",
        //             "agencyName": "Example Agency",
        //             "contractUpload": "asf",
        //             "logo": "ee",
        //             "coverImage": "qq",
        //             "address": "1234 Main St, Anytown, USA",
        //             "owner": "John Doe",
        //             "email": "john.doe@example.com",
        //             "contactNumber": "+1234567890",
        //             "ownerImage": "0000000000000",
        //             "ownerCoverImage": "qq",
        //             "isActive": true,
        //             "createdAt": "2024-08-03T10:30:23.294Z",
        //             "updatedAt": "2024-08-05T04:16:09.862Z",
        //             "__v": 0
        //         },
        //         "isActive": true,
        //         "isDeleted": false,
        //         "userType": "60d21b4667d0d8992e610c86",
        //         "createdAt": "2024-08-05T02:56:48.904Z",
        //         "updatedAt": "2024-08-05T04:19:36.519Z",
        //         "__v": 0
        //     }
        // ]

    this.agencyDetailsFlag=true
    this.addStaffFlag=false
    this.editStaffFlag=false
  }

  selectedStaff(staff:any){
  
    
this.selectedStaffData=staff

// this.selectedStaffData={
//   name: "john",
//   phone: "87687687",
//   whatsApp: "768768768",
//   address: "kjkhkhkh kjhkhjkjhk kjhjkhkj",
//   email: "email.email.com",
//   userName: "email.com",
//   password: "34234",
//   logo: "../../assets/images/user1.jpeg",
//   coverImage: "../../assets/images/user1.jpeg",


// }
this.viewStaffFlag=true
this.agencyDetailsFlag=false
 this.staffForm.value.logo= this.selectedStaffData.logo
 this.staffForm.get('photo')?.patchValue(this.selectedStaffData.photo);
 this.staffForm.get('coverImage')?.patchValue(this.selectedStaffData.coverImage);

      }


      editAgency(){


        this.agencyForm.get('logo')?.patchValue(this.selectedAgencyDetails.logo);
        this.agencyForm.get('coverImage')?.patchValue(this.selectedAgencyDetails.coverImage);

        this.agencyForm.get('ownerImage')?.patchValue(this.selectedAgencyDetails.ownerImage);
        this.agencyForm.get('ownerCoverImage')?.patchValue(this.selectedAgencyDetails.ownerCoverImage);
        this.editAgencyFlag=true
        this.agencyDetailsFlag=false
      }

  isSelected(id: any): boolean {
    // console.log("fgfh",id);
    
    localStorage.setItem("CurentAgencyId",id)
    return this.selectedAgencyId === id;
   
  }
  isImage(url: string): boolean {
    // Logic to check if URL ends with common image extensions (example)
    return /\.(jpg|jpeg|png|gif)$/i.test(url);
  }
  
  isPDF(url: string): any {
    // Logic to check if URL ends with .pdf (example)
    if(url)
    return url.toLowerCase().endsWith('.pdf');
  }



  staffCrud(type:any){
    if(type=='Add'){
      console.log("czxc",this.selectedAgencyDetails);
      
      
      // localStorage.setItem("CurentAgencyId",this.selectedAgencyDetails._id)

      this.staffForm.value.agencyRefId=this.selectedAgencyDetails._id
      this.staffForm.value.userType=this.userTypeId
      // this.staffForm.value.userType.push(this.userTypeId)
      this.agencyService.addStaff(this.token,this.staffForm.value)
              .subscribe((response: any) => {
                if (response.status&&response.status === 1) {
                 Swal.fire("Success")
                  this.selectAgency(response.data.agencyRefId)
                  
                  localStorage.setItem("CurentAgencyId",response.data.agencyRefId)

                  this.selectedAgencyId=response.data.agencyRefId

              }else{
                Swal.fire("Failed")

              }
              })
    }else if(type=='Edit'){
      this.staffForm.value.userId=this.selectedStaffData._id
      // this.staffForm.value.id=this.selectedStaffData._id
      // localStorage.setItem("CurentAgencyId",this.selectedAgencyDetails._id)
      this.agencyService.updateStaff(this.token,this.staffForm.value)
              .subscribe((response: any) => {
                if (response.status&&response.status === 1) {
                  Swal.fire("Success")

                  this.selectAgency(response.data.agencyRefId)
                  
                  localStorage.setItem("CurentAgencyId",response.data.agencyRefId)

                  this.selectedAgencyId=response.data.agencyRefId
                  // console.log(localStorage.getItem("CurentAgencyId"));
                  // localStorage.setItem("CurentAgencyId",response.data._id)
                  // this.selectAgency(response.data._id)
                  // this.selectedAgencyId=response.data._id
                  

              }else{
                Swal.fire("Failed")

              }
              })


    }
   
    

  }

  agencyCrud(type:any){
    if(type=='Add'){
      // this.staffForm.value.agencyId=this.selectedAgencyId
      this.agencyService.addAgency(this.token,this.agencyForm.value)
              .subscribe((response: any) => {
                console.log(response.status&&response.status);

                if (response.status&&response.status === 1) {
                  Swal.fire("Success")

                  this.listAgency()
                  this.addAgencyFlag=false
                  this.selectAgency(response.data._id)

                  this.agencyDetailsFlag=true
                  this.agencyForm.reset()
                  
               }else{
                Swal.fire("Failed")

              }
              })
    }else if(type=='Edit'){
      this.agencyForm.value.agencyId=this.selectedAgencyDetails._id
      // this.agencyForm.value._id=this.selectedAgencyDetails._id
      // this.agencyForm.value.id=this.selectedStaffData._id
      this.agencyService.updateAgency(this.token,this.agencyForm.value)
              .subscribe((response: any) => {
                console.log(response.status);
                
                if (response.status&&response.status === 1) {
                  Swal.fire("Success")

                  // this.selectAgency(this.selectedAgencyDetails._id)
                  this.listAgency()

                  this.agencyForm.reset()
                  this.editAgencyFlag=false
                  this.selectAgency(response.data._id)

                  this.agencyDetailsFlag=true

                }else{
                  Swal.fire("Failed")
  
                }
              })


    }
   
    

  }


  upload(key:any,data:any){
console.log(data,key);

    this.agencyService.UploadSingle(data.target.files[0], this.token)
    .subscribe((response: any) => {
        if (response.status === 1) {

          Swal.fire("Uploaded")
          if (key == "staffLogo") {
            this.staffForm.get('photo')?.patchValue(response.data);

          }
          else if(key=='staffCoverLogo'){
            this.staffForm.get('coverImage')?.patchValue(response.data);

          }
          else if(key=='agencyLogo'){
console.log("df");

            this.agencyForm.get('logo')?.patchValue(response.data);
            console.log("ffggf",this.agencyForm.value);
            

          }
          else if(key=='agencyCoverImage'){

            this.agencyForm.get('coverImage')?.patchValue(response.data);

          }
          else if(key=='ownerLogo'){
            this.agencyForm.get('ownerImage')?.patchValue(response.data);

          }
          else if(key=='ownerCoverImage'){
            this.agencyForm.get('ownerCoverImage')?.patchValue(response.data);

          }
          else if(key=='contract'){
            this.agencyForm.get('contractUpload')?.patchValue(response.data);

          }
        
        
        
        
        
        
        }})






  }


  disableAgency(){
    let request={
      agencyId:this.selectedAgencyDetails._id,
      isActive:false
    }

    this.agencyService.disableAgency(this.token,request)
    .subscribe((response: any) => {
      if (response.status === 1) {
        this.selectedAgencyDetails={}
        this.agencyDetailsFlag=false
     }
    })


  }
 
}
